import React, { useState, useRef, useEffect } from "react"
import Input from "@kit/design/input"
import Button from "@kit/design/button"
import Checkbox from "@kit/design/checkbox"
import { getCreator } from "app/shared/assets/creators"
import KitLogo from "./assets/kit-logo.svg"
import Note from "@kit/design/note"
import googleLogo from "../../../assets/images/oauth/google.png"

// eslint-disable-next-line import/no-default-export
export default function Login(props) {
  const [emailHasValue, setEmailHasValue] = useState(!!window.chrome)
  const [passwordHasValue, setPasswordHasValue] = useState(!!window.chrome)
  const [disabled, setDisabled] = useState(false)
  const emailInput = useRef(null)
  const passwordInput = useRef(null)
  const [creator, setCreator] = useState(null)

  const signupLink = new URL(props.signupLink, window.location.origin)
  const currentParams = new URLSearchParams(window.location.search)
  currentParams.forEach((value, key) => signupLink.searchParams.set(key, value))

  useEffect(() => {
    setCreator(getCreator())
  }, [])

  return (
    <div className="md:grid grid-cols-2 w-full bg-warm-white-100">
      <div className="px-4 pb-40 pt-2">
        <div style={{ maxWidth: "470px" }} className="mx-auto">
          <div className="flex md:pb-16 pb-8">
            <KitLogo
              className="mt-4"
              width="70.85"
              height="32"
              arial-label="Kit logo"
            />
          </div>

          {props.errorMessage && (
            <Note type="error" className="mb-4">
              {props.errorMessage}
            </Note>
          )}

          <div className="flex mb-6">
            <div className="block hover:no-underline no-underline font-semibold text-center w-1/2 border-b-2 py-2 text-gray-900 border-gray-900">
              Log in
            </div>
            <a
              href={signupLink}
              className="hover:border-gray-500 hover:no-underline no-underline block text-center w-1/2 border-b py-2"
            >
              Create account
            </a>
          </div>

          <div>
            <form
              className="form-vertical form--lg"
              id="new_user"
              action={props.formAction}
              acceptCharset="UTF-8"
              method="post"
              onSubmit={() => setDisabled(true)}
            >
              {props.invitationFrom && (
                <div className="accept-invite-notice">
                  You are accepting an invite to join{" "}
                  <b>{props.invitationFrom}</b> account. Log in to accept the
                  invite.
                </div>
              )}

              <div className="mb-6 flex">
                <div className="w-full">
                  <label htmlFor="user_email" className="flex">
                    <div className="pb-2 font-semibold text-gray-900 pr-px">
                      Email
                    </div>
                    <div className="text-orange-500">*</div>
                  </label>
                  <Input
                    placeholder="E.g; jane@company.com"
                    style={{ borderRadius: "7px" }}
                    name="user[email]"
                    id="user_email"
                    /* eslint-disable-next-line */
                    autoFocus
                    className={`w-full h-10 border border-gray-200 hover:border-gray-300 focus:outline-blue ${
                      emailHasValue ? "not-empty" : ""
                    }`}
                    type="text"
                    ref={emailInput}
                    onChange={() =>
                      setEmailHasValue(!!emailInput.current.value.length)
                    }
                  />
                </div>
              </div>
              <div className="mb-4 flex">
                <div className="w-full">
                  <label
                    htmlFor="user_password"
                    className="flex justify-between items-center pb-2"
                  >
                    <div className="flex font-semibold text-gray-900">
                      <span className="pr-1">Password</span>
                      <span className="text-orange-500">*</span>
                    </div>
                    <p className="flex justify-center text-xs underline text-gray-700">
                      <a href={props.passwordLink}>Forgot password?</a>
                    </p>
                  </label>
                  <Input
                    style={{ borderRadius: "7px" }}
                    placeholder="**********"
                    name="user[password]"
                    id="user_password"
                    className={`w-full h-10 border-gray-200 hover:border-gray-300 focus:outline-blue ${
                      passwordHasValue ? "not-empty" : ""
                    }`}
                    type="password"
                    ref={passwordInput}
                    onChange={event => {
                      setPasswordHasValue(!!event.target.value.length)
                    }}
                  />
                </div>
              </div>
              <input
                type="hidden"
                name="authenticity_token"
                value={props.authenticityToken}
              />
              <input name="utf8" type="hidden" value="✓" />
              <div className="pt-2 pb-6 text-xs">
                <Checkbox
                  name="user[remember_me]"
                  id="user_remember_me"
                  value="1"
                />
                <label
                  className="ml-2"
                  style={{ marginTop: "2px" }}
                  htmlFor="user_remember_me"
                >
                  Keep me logged in on this device
                </label>
              </div>
              <Button
                id="user_log_in"
                is="primary-blue"
                size="lg"
                className="w-full"
                disabled={disabled}
              >
                Log in
              </Button>
            </form>
          </div>
          {props.googleSso && (
            <>
              <div className="flex items-center text-center py-4">
                <hr className="flex-grow" />
                <span className="px-3 text-gray-700 font-semibold">OR</span>
                <hr className="flex-grow" />
              </div>
              <Button
                is="secondary"
                size="lg"
                className="w-full"
                href="/auth/google_oauth2_user?flow=login"
              >
                <img
                  src={googleLogo}
                  alt="Google logo"
                  className="h-5 w-5 mr-3"
                />
                Log in with Google
              </Button>
            </>
          )}
        </div>
      </div>
      <aside className="hidden md:flex items-center justify-center min-h-full max-h-screen relative overflow-hidden">
        {creator && (
          <React.Fragment>
            <img
              src={creator.img}
              alt={creator.name}
              className="object-cover object-center min-h-full"
            />
            <div
              className="rounded-l rounded-br absolute bottom-0 right-0 mr-8 mb-8 h-20 w-40 p-4 flex flex-col"
              style={{ background: "rgba(238, 246, 243, .9)" }}
            >
              <span className="text-base pb-2 font-semibold">
                {creator.name}
              </span>
              <span className="italic">{creator.business}</span>
            </div>
          </React.Fragment>
        )}
      </aside>
    </div>
  )
}
